{
    "nav": {
        "dashboard": "Experience",
        "surveys": "Surveys",
        "distributions": "Sending",
        "journeys": "Journeys",
        "verbatims": "Verbatims",
        "actions": "Improvement actions"
    },
    "dashboard": {
        "title": "Customer experience",
        "subtitle": "Scores, drivers and what is being done",
        "index": "Score",
        "nps": "Net Promoter Score",
        "csat": "Satisfaction",
        "ces": "Customer Effort",
        "base": "{{count}} responses",
        "unreliable": "Too few responses to rely on",
        "promoters": "Promoters",
        "passives": "Passives",
        "detractors": "Detractors",
        "responses": "Responses",
        "invited": "Invited",
        "response_rate": "Response rate",
        "awaiting_follow_up": "Detractors not yet contacted",
        "vs_previous": "vs previous period",
        "no_comparison": "No comparable period",
        "trend": "Trend",
        "by_channel": "By channel",
        "drivers": "What moves the score",
        "driver_impact": "Impact",
        "driver_mentions": "{{count}} mentions",
        "driver_explanation": "Customers who mentioned this scored {{points}} points differently from those who did not.",
        "emerging": "Rising themes",
        "emerging_new": "New",
        "emerging_multiple": "×{{multiple}} vs baseline",
        "no_data": "No responses match these filters.",
        "map": "By governorate",
        "branches": "By branch",
        "filters": "Filters",
        "survey": "Survey",
        "all_surveys": "All surveys",
        "channel": "Channel",
        "all_channels": "All channels",
        "from": "From",
        "to": "To",
        "apply": "Apply"
    },
    "survey": {
        "title": "Surveys",
        "code": "Code",
        "name": "Name",
        "type": "Type",
        "status": "Status",
        "channels": "Channels",
        "questions": "Questions",
        "responses": "Responses",
        "new": "New survey",
        "edit": "Edit",
        "save": "Save survey",
        "preview": "Preview",
        "preview_on": "Preview on",
        "untranslated": "{{count}} questions are missing a translation",
        "translated": "Every question is written in both languages",
        "name_en": "Name (English)",
        "name_ar": "Name (Arabic)",
        "intro_en": "Introduction (English)",
        "intro_ar": "Introduction (Arabic)",
        "thanks_en": "Thank-you message (English)",
        "thanks_ar": "Thank-you message (Arabic)",
        "expiry_days": "Invitation valid for (days)",
        "estimated_minutes": "Estimated minutes",
        "allows_anonymous": "Accept anonymous responses",
        "add_question": "Add question",
        "question_key": "Key",
        "question_type": "Type",
        "text_en": "Question (English)",
        "text_ar": "Question (Arabic)",
        "required": "Required",
        "is_index": "This is the score question",
        "is_verbatim": "Analyse this comment for themes",
        "scale": "Scale",
        "scale_fixed": "Fixed by the question type",
        "options": "Options",
        "add_option": "Add option",
        "option_value": "Value",
        "label_en": "Label (English)",
        "label_ar": "Label (Arabic)",
        "rules": "Branching",
        "add_rule": "Add rule",
        "rule_when": "When the answer",
        "rule_then": "then",
        "rule_target": "go to",
        "remove": "Remove",
        "statuses": {
            "draft": "Draft",
            "active": "Active",
            "paused": "Paused",
            "archived": "Archived"
        },
        "types": {
            "nps": "NPS",
            "csat": "CSAT",
            "ces": "CES",
            "custom": "Custom"
        }
    },
    "distribution": {
        "title": "Sending",
        "new": "New send",
        "name": "Name",
        "survey": "Survey",
        "channel": "Channel",
        "segment": "Audience segment",
        "all_customers": "Everybody",
        "scheduled_for": "Send at",
        "closes_at": "Close at",
        "quota": "Maximum invitations",
        "reminders": "Reminders",
        "reminder_after": "Remind after (days)",
        "start": "Start",
        "invited": "Invited",
        "responded": "Responded",
        "suppressed": "Not contacted",
        "response_rate": "Response rate",
        "status": "Status",
        "qr_posters": "QR posters",
        "create_poster": "Create poster",
        "poster_branch": "Branch",
        "poster_placement": "Where it is displayed",
        "poster_created": "Poster created",
        "poster_url": "Poster link",
        "print": "Print poster",
        "scan_me": "Scan to tell us how we did",
        "statuses": {
            "draft": "Draft",
            "scheduled": "Scheduled",
            "running": "Sending",
            "completed": "Finished",
            "cancelled": "Cancelled"
        }
    },
    "journey": {
        "title": "Journeys",
        "new": "New journey",
        "name": "Name",
        "event": "When this happens",
        "survey": "Send this survey",
        "channel": "By",
        "delay": "Wait (minutes)",
        "delay_help": "Asking somebody how it went while they are still annoyed gives a different answer from asking tomorrow.",
        "conditions": "Only when",
        "add_condition": "Add condition",
        "field": "Field",
        "operator": "Is",
        "value": "Value",
        "respect_suppression": "Respect suppression rules",
        "active": "Active",
        "fired": "Fired {{count}} times",
        "never_fired": "Not yet fired",
        "save": "Save journey",
        "immediately": "Immediately"
    },
    "verbatims": {
        "title": "What customers said",
        "filter_theme": "Theme",
        "all_themes": "All themes",
        "filter_band": "Band",
        "all_bands": "All bands",
        "evidence": "Matched on",
        "no_comments": "No comments match these filters.",
        "follow_up": "Mark as followed up",
        "followed_up": "Followed up",
        "needs_follow_up": "Needs follow-up",
        "anonymous": "Anonymous",
        "raise_action": "Raise an action"
    },
    "actions": {
        "title": "Improvement actions",
        "new": "New action",
        "action_title": "What will be done",
        "description": "Detail",
        "owner": "Owner",
        "branch": "Branch",
        "theme": "Theme",
        "due": "Due",
        "priority": "Priority",
        "measure_after": "Measure after (days)",
        "save": "Save action",
        "baseline": "Score before",
        "outcome": "Score after",
        "movement": "Change",
        "not_measured": "Not yet measured",
        "overdue": "Overdue",
        "columns": {
            "proposed": "Proposed",
            "in_progress": "In progress",
            "blocked": "Blocked",
            "done": "Done",
            "cancelled": "Cancelled"
        }
    },
    "public": {
        "loading": "Loading…",
        "expired": "This link is no longer valid.",
        "submit": "Send",
        "next": "Next",
        "back": "Back",
        "progress": "Question {{current}} of {{total}}",
        "required": "This question needs an answer.",
        "thanks_title": "Thank you",
        "powered": "Development Bank",
        "choose": "Choose one",
        "choose_many": "Choose any that apply",
        "your_answer": "Your answer",
        "yes": "Yes",
        "no": "No"
    },
    "bands": {
        "promoter": "Promoter",
        "passive": "Passive",
        "detractor": "Detractor"
    },
    "channels": {
        "web": "Web form",
        "email": "Email",
        "sms": "SMS",
        "whatsapp": "WhatsApp",
        "qr": "QR code",
        "voice": "Automated call",
        "agent": "Agent-assisted"
    },
    "simulators": {
        "title": "Other channels",
        "subtitle": "WhatsApp, an automated call, and a survey read out by a member of staff — all driven by the endpoint the customer’s own device calls.",
        "start": "Start",
        "idle": "Choose a survey and start to see what this channel actually sends.",
        "keypad": "Keypad entry",
        "completed": "Completed — the response has been recorded."
    },
    "question_types": {
        "nps": "NPS (0–10)",
        "csat": "Satisfaction",
        "ces": "Effort",
        "rating": "Rating",
        "scale": "Scale",
        "single_choice": "Choose one",
        "multi_choice": "Choose any",
        "text": "Short text",
        "long_text": "Comment",
        "boolean": "Yes or no",
        "date": "Date",
        "number": "Number"
    },
    "operators": {
        "equals": "is",
        "not_equals": "is not",
        "less_than": "is less than",
        "greater_than": "is greater than",
        "in": "is one of",
        "contains": "contains",
        "answered": "was answered",
        "skipped": "was skipped",
        "is_null": "is empty",
        "not_null": "is not empty"
    },
    "rule_actions": {
        "skip_to": "jump to",
        "end_survey": "end the survey",
        "show": "show",
        "hide": "hide"
    },
    "embed": {
        "title": "Embed code",
        "generate": "Generate",
        "iframe": "Paste this into the page",
        "link": "Or link to it",
        "link_text": "Tell us how we did",
        "frame_title": "Customer feedback survey",
        "placement": "Where it will appear",
        "placement_example": "e.g. after the loan application page",
        "height": "Height (pixels)",
        "anonymous_only": "Only surveys that accept anonymous answers can be embedded — a public page has no customer to attach a response to.",
        "reuse_warning": "This link stays valid and can be answered more than once, which is what an embedded survey needs. Do not send it to an individual customer; use a distribution for that."
    }
}
